import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const reviews = [
  { textKey: 'review_1_text', authorKey: 'review_1_author', detailKey: 'review_1_detail' },
  { textKey: 'review_2_text', authorKey: 'review_2_author', detailKey: 'review_2_detail' },
  { textKey: 'review_3_text', authorKey: 'review_3_author', detailKey: 'review_3_detail' },
];

export default function TemoignagesRapides() {
  const { t } = useTranslation('soumission');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="reviews" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('reviews_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((review, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl p-6 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 120 + 200}ms` }}
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-copper text-sm" />
                ))}
              </div>
              <p className="text-slate-primary/70 text-sm leading-relaxed mb-4">
                "{t(review.textKey)}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-copper/10 flex items-center justify-center">
                  <span className="text-copper font-bold text-sm">
                    {t(review.authorKey).split(' ')[0][0]}{t(review.authorKey).split(' ')[1]?.[0] || ''}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-slate-primary text-sm">{t(review.authorKey)}</p>
                  <p className="text-gray-400 text-xs">{t(review.detailKey)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <p className="text-slate-primary/40 text-xs mt-8 text-center italic max-w-3xl mx-auto">
        Témoignages représentatifs de clients ayant utilisé notre service de mise en relation.
      </p>
    </section>
  );
}